import React, { Component, Fragment } from 'react'
import { Button, Col, Container, Row} from 'react-bootstrap'
import '../../asset/css/custom.css';
import '../../asset/css/bootstrap.min.css';




import hall1D from '../../asset/image/flyer2.jpg';
import hall2D from '../../asset/image/mar2026.png';


import Carousel from 'react-bootstrap/Carousel';


export class TopBanner extends Component {
  render() {
    return (
     <Fragment>
        <Container fluid={true} className='topFixedBanner p-0'>
           <div className='topBannerOverlay'>
             
                   
                     <Carousel interval={9000} >
      <Carousel.Item>
        <img
          className="d-block imageSize"
          src={hall2D}
          alt="First slide"
        
        />
        <Carousel.Caption>
          <h5></h5>
      
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block imageSize"
          src={hall1D}
          alt="Second slide"
        />
        <Carousel.Caption>
          <h5></h5>
        
        </Carousel.Caption>
      </Carousel.Item>
     
    </Carousel>
                


            </div>
        </Container>

     </Fragment>
    )
  }
}

export default TopBanner
